import { useScrollReveal } from "@/hooks/useScrollReveal";
import SectionTitle from "./SectionTitle";

export default function RecruitMessageSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] overflow-hidden" id="message">
      {/* 背景画像を画面いっぱいに広げる */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="/images/GRANSTARK-OSAKA_office1_president's seat.jpeg"
          alt="GRANSTARK代表・三田晃士のオフィス"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {/* 明るいグレーのオーバーレイ */}
        <div className="absolute inset-0 bg-gray-200/70 pointer-events-none" />
      </div>

      {/* コンテンツ */}
      <div
        ref={ref}
        className="relative z-10 flex items-center justify-center min-h-[600px] md:min-h-[700px]"
      >
        <div
          className={`w-full max-w-5xl px-8 md:px-16 lg:px-24 py-16 md:py-24 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <SectionTitle
            en="MESSAGE"
            ja="代表メッセージ"
            centered={false}
          />
          <h3 className="text-[24px] md:text-3xl lg:text-4xl font-bold text-navy mb-6 md:mb-8 leading-relaxed">
            「警備の未来も、生活も、守る。」
          </h3>
          <div className="text-navy/90 leading-loose space-y-4 md:space-y-5 text-base md:text-lg">
            <p>
              はじめまして、代表の三田です。私たちは2019年に法人設立した、まだ若い警備会社です。もともと私は警備とは全く違う不動産業界におりました。その中で、某国際イベントや統合型リゾートなど、大阪が大きく発展していく姿を見てきました。この大阪の発展に、インフラに欠かせない仕事で貢献できないか&#8212;そう考えていたとき、警備会社にいたメンバーと出会ったのがきっかけです。
            </p>
            <p>
              警備業界は伝統のある分、変化が少ない部分もあります。私は違う業界にいたからこそ、「警備業界の概念を変えたい」と本気で思っています。そのためにまず変えたいのが、働く環境です。私ができることは、社員が安心して働ける環境としっかり稼げる仕事をつくること。私たちは規律を大切にしながらも、窮屈な会社にはしたくないと考えています。シフトは毎週提出制にしたり、日払い・週払いにも柔軟に対応しています。これは決して甘さではなく、当たり前のやさしさであり、社員の&quot;安心&quot;のためだと考えています。
            </p>
            <p>
              経験は問いません。私たちの想いに共感し、一緒に新しい警備のスタンダードをつくってくれる仲間をお待ちしています。
            </p>
          </div>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="text-navy font-bold text-xl md:text-2xl">
              代表取締役　三田　晃士
            </p>

          </div>
        </div>
      </div>
    </section>
  );
}